"use client";

import { useState, useRef, useEffect } from "react";
import { useRouter } from "next/navigation";
import AlertBox from "@/design-system/alertbox/alertbox";
import  InputText  from "@/design-system/input/input";
export default function Login() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const [error, setError] = useState<string | null>(null); // État pour afficher les erreurs
  const router = useRouter();
  const inputRef =  useRef<HTMLInputElement|null>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Empêche le rechargement de la page

    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password, rememberMe }),
      });

      if (response.status === 200) {
        //const data = await response.json();
        //localStorage.setItem("token", data.token); // Stocke le token JWT (facultatif)
        router.push("/"); // Redirige vers la page d'accueil
      } else {
        const data = await response.json();
        setError(data.error); // Affiche une erreur

      }
    } catch  {
      setError("Failed to connect to the server.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-700 ">
        {/* Titre */}
        <div className="flex  w-96 pt-8 mb-10 mh-10">
          <h2 className="flex items-center justify-center rounded-md text-2xl font-bold text-white bg-black h-[50] w-full">
            Authentification
          </h2>
        </div>
        {error && (
          <AlertBox className="w-96" text={error} />
        )}
      <div className="bg-white shadow-lg rounded-md p-8 w-96  top-[100px]">

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <InputText ref={inputRef} label="Username" type="text"  id="username" name="username" onChange={(e) => setUsername(e.target.value)} value={username} />
          </div>
          <div>
            <InputText label="Password" type="password"  id="password" name="password" onChange={(e) => setPassword(e.target.value)} value={password} />
          </div>
          <div>
            <label className="flex items-center gap-2 text-black">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="h-4 w-4 text-black border-gray-300 rounded focus:ring-black"
              />
              Se souvenir de moi
            </label>
          </div>
          {/* Bouton */}
          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded-md hover:bg-gray-800 transition duration-200"
          >
            Send
          </button>
        </form>
      </div>
    
    </div>
  );
  }




 